import { type NotificaUtenteResponseDTO } from '@framework/api-client/api/inquiries-compile/schemas/notificaUtenteResponseDTO.ts';

export function checkNotificationsToRead(
  notifications: NotificaUtenteResponseDTO[] | null | undefined,
): boolean {
  return (
    notifications?.some(notification => !notification.dataPresaVisione) ?? false
  );
}
